const API_URL = process.env.REACT_APP_BACKEND_URL;

if (!API_URL) {
  console.error('REACT_APP_BACKEND_URL environment variable is not configured');
}

export const villagesAPI = {
  // Get all villages
  getAll: async () => {
    const response = await fetch(`${API_URL}/api/villages`);
    if (!response.ok) {
      throw new Error('Failed to fetch villages');
    }
    return response.json();
  },

  // Add new village
  add: async (villageData) => {
    const response = await fetch(`${API_URL}/api/villages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(villageData),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to add village');
    }
    return response.json();
  },

  // Update village
  update: async (villageId, updates) => {
    const response = await fetch(`${API_URL}/api/villages/${villageId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updates),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to update village');
    }
    return response.json();
  },

  // Delete village
  delete: async (villageId) => {
    const response = await fetch(`${API_URL}/api/villages/${villageId}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to delete village');
    }
    return response.json();
  },
};
